module.exports = __webpack_public_path__ + "img/download.b47f3c68.svg";